module.exports = __webpack_public_path__ + "img/requirement-types.b22d32f4.svg";